// Styles
import "../../stylesheets/frontend/home.css";

document.addEventListener("turbolinks:load", function() {});
